import { initializeErrorReporting } from '@eventbrite/error-reporting';

export const initializeErrorReportingAuth = () => {
    initializeErrorReporting({
        dsn: 'https://3790e637446c42a3a7f30f5868ec3159@o375540.ingest.sentry.io/5902718',
    });
};
